import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./pages/Admin/Dashboard";
import Reporte from "./pages/Public/Reporte";

function App() {
  return (

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Reporte />} />
        <Route path="/admin" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;